import styled from "styled-components";

const Container = styled.div``;
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
  background-color: #f8fafc;
 margin-top: 20px;

  .text-box {
   text-align: center;
   padding-top: min(10.417vw, 150px);
   color: black;
  }
  
  .carousel-img-container {
    position: relative;
    display: flex;
    flex-direction: column;
    /* height: 104%; */
  }
  .carousel-img {
    max-width: min(43.056vw,620px);
    margin: min(6.944vw,100px) auto min(10.417vw,150px);
    width: 100%;
  }
  .text-box-heading {
    position: absolute;
    top: 23%;
    left: 11%;
    /* width: min(52.431vw,755px);     */
     background: radial-gradient(#000000,#00000000); 
    /* text-shadow: 4px 6px 30px rgba(0, 0, 0, 1); */
  }
  h2 {
    font-size: min(1.667vw, 24px);
    line-height: 200%;
    /* line-height: min(3.15vw, 45px); */
    font-family: 'GothamBookBold';
    margin: 0;
    padding: 3px;
    font-size: 30px;
    /* letter-spacing: min(0.169vw, 2.43px); */
  }
  .text-box-subheading {
    position: absolute;
    top: 40%;
    left: 11%;
    /* width: min(52.431vw,755px);     */
     background: radial-gradient(#000000,#00000000); 
    /* text-shadow: 4px 6px 30px rgba(0, 0, 0, 1); */
  }
  a.internal-links{
    text-decoration: underline !important;
  }
  a.internal-links:hover{
    color: #70ac08 !important;
  }
  h6 {
    color: #fff;
    font-size: min(1.667vw, 24px);
    font-family: "robotobold";
    margin: 0;
    letter-spacing: min(0.099vw, 1.43px);
  }

  .tell-more-btn {
    position: absolute;
    top: 76%;
    left: 11%;

    background-color: #fff;
    color: #0a5587;
    width: min(15.13vw, 189px);
    height: min(2.73vw, 39px);
    font-size: min(1.19vw, 17px);
    border-radius: min(0.42vw, 6px);
    border: none;
    cursor: pointer;
    font-family: "robotoregular";
    margin-top: min(1.75vw, 25px);
  }
  .mobile-view-loading-page {
    display: none;
  }
  > div {
    flex: 1;
  }
  @media (max-width: 767px) {
    padding: 0px;
    margin: 0;
    .carousel-img-container {
      height: auto;
    }
    h2 {
      font-size: 2.2vw;
    }
    .carousel-img {
      width: 100%;
      margin: min(8.944vw,100px) auto min(19.417vw,150px);
      max-width: min(80vw,450px);
    }
    .text-box {
      padding-top: min(18vw, 100px);
    }
    .text-box-heading {
      left: 0;
      right: 0;
      top: 3%;
      h2 {
        font-size: 8.7vw;
        line-height: 10.16vw;
        text-align: center;
      }
    }

    .text-box-subheading {
      left: 0;
      right: 0;
      top: 27%;
      h6 {
        margin: 0;
        font-size: 4.84vw;
        line-height: 6.292vw;
        max-width: 100%;
        text-align: center;
      }
    }

    .tell-more-btn {
      width: 39.7vw;
      height: 7.74vw;
      font-size: 3.38vw;
      border-radius: 6px;
      top: 80%;
      left: 29%;
    }
    /* .tell-more-btn {
      left: 18%;
      font-size: 10px;
      padding: 3px 14px;
    } */
    .mobile-view-loading-page {
      display: block;
      width: 94.138vw;
    }
  }
  @media (max-width: 575px) {
    h2 {
    font-size: 4.5vw;
    max-width: 85%;
    margin: 24px auto;
}
  }
`;

export { Container, Wrapper };
